import React, { useEffect, useState } from "react";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";
import DatePicker from "react-multi-date-picker";

export default function AllContractsReport({ lang, dirFormat }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [contractList, setContractList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [filter, setFilter] = useState("");
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  function convertDateFormat(inputDate) {
    if (!inputDate) return "";
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return dateObject.toLocaleDateString("en-GB", options);
  }

  const columns = [
    {
      header: lang.reference_number || "Reference Number",
      accessorKey: "id",
      cell: (row) => row.getValue() * 9999,
      footer: () => lang["Total"] || "Total",
    },
    {
      header: lang.Clients || "Clients",
      accessorKey: "customer_name",
    },
    {
      header: lang.Identity_Number || "Identity Number",
      accessorKey: "customer_validID",
    },
    {
      header: lang.Total || "Total",
      accessorKey: "total_value",
      cell: (row) => Number(row.getValue() || 0).toFixed(2),
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { total_value } = row.original;
            return sum + Number(total_value || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Date_of_Contract || "Date of Contract",
      accessorKey: "date_contract",
      cell: (row) => <p>{convertDateFormat(row.getValue())}</p>,
    },
    {
      header: lang.due_date || "Due Date",
      accessorKey: "due_date",
      cell: (row) => <p>{convertDateFormat(row.getValue())}</p>,
    },
    {
      header: lang.branch_name || "Office/Branch",
      accessorKey: "office_name",
    },
  ];

  // Fetch branches for dropdown filter
  useEffect(() => {
    axios
      .get(apiKey + "/get-dealers", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setBranchList(res.data.result || []);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [token]);

  // Fetch all contracts based on filters
  useEffect(() => {
    let fromDateStr = "";
    let toDateStr = "";

    if (filter === "from_to") {
      if (from) {
        fromDateStr = new Date(from).toISOString().split("T")[0];
      }
      if (to) {
        toDateStr = new Date(to).toISOString().split("T")[0];
      }
    } else if (filter) {
      // Calculate from/to dates based on filter type
      const today = new Date();
      if (filter === "today") {
        fromDateStr = today.toISOString().split("T")[0];
        toDateStr = today.toISOString().split("T")[0];
      } else if (filter === "this_week") {
        const first = today.getDate() - today.getDay();
        const last = first + 6;
        fromDateStr = new Date(today.setDate(first)).toISOString().split("T")[0];
        toDateStr = new Date(today.setDate(last)).toISOString().split("T")[0];
      } else if (filter === "this_month") {
        fromDateStr = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split("T")[0];
        toDateStr = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split("T")[0];
      } else if (filter === "this_year") {
        fromDateStr = new Date(today.getFullYear(), 0, 1).toISOString().split("T")[0];
        toDateStr = new Date(today.getFullYear(), 11, 31).toISOString().split("T")[0];
      }
    }

    axios
      .get(apiKey + "/all-contracts", {
        params: {
          from: fromDateStr || undefined,
          to: toDateStr || undefined,
          branch_id: selectedBranch || undefined,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setContractList(res.data.result || []);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [token, filter, from, to, selectedBranch]);

  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang["All Contracts Report"] || "All Contracts Report"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">{lang.Reports || "Reports"}</li>
              <li className="breadcrumb-item active">
                {lang["All Contracts"] || "All Contracts"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="mt-3 mb-3">
                    <div className="rr">{lang["All Contracts Report"] || "All Contracts Report"}</div>

                    <div className="row justify-content-end gap-2">
                      {filter === "from_to" && (
                        <>
                          <div className="custom-datepicker">
                            <DatePicker
                              className="form-control w-100"
                              placeholder={lang["from_text"] || "From"}
                              style={{
                                left: "35%",
                                top: "5px",
                                height: "auto",
                              }}
                              containerStyle={{
                                height: "auto",
                              }}
                              onChange={(e) => {
                                const dateObject = new Date(e);
                                setFrom(dateObject);
                              }}
                            />
                          </div>
                          <div className="custom-datepicker">
                            <DatePicker
                              className="form-control w-100"
                              placeholder={lang["to_text"] || "To"}
                              style={{
                                left: "45%",
                                top: "5px",
                                height: "auto",
                              }}
                              containerStyle={{
                                height: "auto",
                              }}
                              onChange={(e) => {
                                const dateObject = new Date(e);
                                setTo(dateObject);
                              }}
                            />
                          </div>
                        </>
                      )}
                      <select
                        onChange={(e) => setSelectedBranch(e.target.value)}
                        name=""
                        id=""
                        className="form-data col-3 btn-export"
                        style={{ top: "48px" }}
                      >
                        <option value="">
                          {lang.branch_name || "All Branches"}
                        </option>
                        {branchList.map((branch, index) => (
                          <option key={index} value={branch.id}>
                            {branch.branch_name}
                          </option>
                        ))}
                      </select>
                      <select
                        onChange={(e) => setFilter(e.target.value)}
                        name=""
                        id=""
                        className="form-data btn-export col-3"
                      >
                        <option value="">{lang.All_Time || "All Time"}</option>
                        <option value="today">{lang.Today || "Today"}</option>
                        <option value="this_week">
                          {lang.This_Week || "This Week"}
                        </option>
                        <option value="this_month">
                          {lang.This_Month || "This Month"}
                        </option>
                        <option value="this_year">
                          {lang.This_Year || "This Year"}
                        </option>
                        <option value="from_to">
                          {lang["From To"] || "From To"}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="d-flex mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={contractList}
                      columns={columns}
                      footer={true}
                      exportOption={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}